module.exports = __webpack_public_path__ + "static/media/hands_06.15733aa1.svg";